import {motion} from "motion/react";
import {FiChevronDown, FiLock} from "react-icons/fi";
import {components, DropdownIndicatorProps} from "react-select";

import {Icon} from "@/components/icon/Icon.tsx";

export const DropdownIndicator = <I,>(props: DropdownIndicatorProps<I>) => {
  const isActive = props.selectProps.menuIsOpen;
  return (
    <components.DropdownIndicator {...props}>
      <motion.div
        className={"ms-auto"}
        initial={{rotate: isActive ? 180 : 0}}
        animate={{rotate: isActive ? 180 : 0}}
        transition={{
          type: "tween",
          duration: 0.3,
        }}
      >
        <Icon icon={FiChevronDown} />
      </motion.div>
    </components.DropdownIndicator>
  );
};

export const LockedDropdownIndicator = <I,>(props: DropdownIndicatorProps<I>) => {
  return (
    <components.DropdownIndicator {...props}>
      <div className={"ms-auto"}>
        <Icon icon={FiLock} />
      </div>
    </components.DropdownIndicator>
  );
};
